import React, { useCallback, useRef } from 'react';
import { ColDef } from 'ag-grid-community';
import { AgGridTable, AgGridTableRef } from '@shared/components/ui/AgGridTable';
import { EligibleStorage } from '../../models/EligibleStorage';

interface EligibleStorageAgGridTableProps {
  storages: EligibleStorage[];
  columnDefs: ColDef[];
  isLoading?: boolean;
  isFetching?: boolean;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  onSelectionChanged?: (selectedStorages: EligibleStorage[]) => void;
}

export const EligibleStorageAgGridTable = React.memo(
  function EligibleStorageAgGridTable({
    storages,
    columnDefs,
    isLoading = false,
    isFetching = false,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    onSelectionChanged,
  }: EligibleStorageAgGridTableProps) {
    const agGridRef = useRef<AgGridTableRef>(null);

    const handleSelectionChanged = useCallback(
      (selectedRows: EligibleStorage[]) => {
        onSelectionChanged?.(selectedRows);
      },
      [onSelectionChanged]
    );

    return (
      <div
        className={
          isFetching
            ? 'opacity-50 pointer-events-none transition-opacity duration-200'
            : ''
        }
      >
        <AgGridTable
          ref={agGridRef}
          data={storages}
          columnDefs={columnDefs}
          height="calc(100vh - 200px)"
          enableSelection={true}
          onSelectionChanged={handleSelectionChanged}
          isLoading={isLoading}
          rowHeight={56}
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
        />
      </div>
    );
  }
);
